<template>
  <div class="dashboard-container">
    <div class="dashboard-text">welcome: {{ name }}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Dashboard',
  computed: {
    ...mapGetters([
      'name'
    ])
  }
}
</script>

<style lang="scss" scoped>
.dashboard-container{
  display: flex;
  background: linear-gradient(45deg, #2e4cb5, transparent);
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 0 !important;
}
.dashboard {
  &-container {
    margin: 30px;
  }
  &-text {
    font-size: 30px;
    line-height: 46px;
  }
}
</style>
